export const HelichrysumIcon = ({ className = "h-6 w-6", strokeWidth }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true" fill="none" data-stroke={strokeWidth}>
    <path d="M20 38V21M20 27l-6.5-6M20 24.5l6.5-7M20 31l-4.5-3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" opacity="0.75" />
    {[
      [20, 13],
      [13, 17.5],
      [27, 15],
      [16, 9.5],
      [24, 7.5],
      [9.5, 12],
      [30.5, 9.5],
    ].map(([x, y]) => (
      <g key={`${x}-${y}`}>
        <circle cx={x} cy={y} r="3.5" fill="currentColor" />
        <circle cx={x} cy={y} r="1.2" fill="#8A5230" opacity="0.55" />
      </g>
    ))}
  </svg>
);
